import {
  GETALLWALLETSLIST_SUCCESS,
  GETALLWALLETSLIST_FAILED,
  RESET_GETALLWALLETSLIST,
  LOADING_GETALLWALLETSLIST,
  NETWORK_ERROR_GETALLWALLETSLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetAllWalletsList = () => {
  return { type: RESET_GETALLWALLETSLIST };
};

const getAllWalletsList = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETALLWALLETSLIST });
  await partnerServices
    .post("getAllWalletsList", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(getAllWalletsListsuccess(res.data));
          break;
        default:
          dispatch(getAllWalletsListFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_GETALLWALLETSLIST, payload: err });
    });
};
function getAllWalletsListsuccess(data) {
  return {
    type: GETALLWALLETSLIST_SUCCESS,
    payload: data,
  };
}
function getAllWalletsListFailed(data) {
  return {
    type: GETALLWALLETSLIST_FAILED,
    payload: data,
  };
}

export { resetGetAllWalletsList, getAllWalletsList };
